var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHigh(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56.92 56.92",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#febc71;}.cls-2{fill:none;stroke:#231f20;stroke-linecap:round;stroke-miterlimit:10;stroke-width:2px;}.cls-3{fill:#231f20;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 28.46,
    cy: 28.46,
    r: 28.46
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M10.79,21.7s4.58,6.21,8.76,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M37.1,21.7s4.58,6.21,8.76,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M13.44,36.5a19.19,19.19,0,0,1,6.82-4.64,23.87,23.87,0,0,1,4-1.27,16.25,16.25,0,0,1,2.09-.34l1-.13,1.07,0a26.34,26.34,0,0,1,4.25.3l2.07.53a9.15,9.15,0,0,1,1,.3l1,.43a17.68,17.68,0,0,1,6.71,4.85h0a.11.11,0,0,1,0,.14.09.09,0,0,1-.12,0,26.09,26.09,0,0,0-7.07-3.51,23.81,23.81,0,0,0-3.84-.9,28.93,28.93,0,0,0-3.94-.17,28.15,28.15,0,0,0-7.78,1.28,30.42,30.42,0,0,0-7.19,3.3.1.1,0,0,1-.14,0,.13.13,0,0,1,0-.12Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHigh);
export default __webpack_public_path__ + "static/media/high.2d0e558f15325820746e136026c0f972.svg";
export { ForwardRef as ReactComponent };